import { MenuItem, Select, SelectChangeEvent } from "@mui/material";
import React from "react";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { ITaskTypeFieldPropUpdate } from "../../FormDesignerTypes";

interface IFontSizeOption {
    class: string;
    class2?: string;
    title: string;
}

interface IFormDesignerComponentPropertiesFontSizeProps {
  taskTypeCol?: ITaskTypeCol;
  sizeOptions: IFontSizeOption[]
  onChange?: (values: ITaskTypeFieldPropUpdate[]) => void;
}

const getTextSize = (classes: string, sizeOptions: IFontSizeOption[]) => {
    for (const sizeOption of sizeOptions) {
        if (classes.includes(" " + sizeOption.class + " ")) return sizeOption.class;
    }
    return "";
};

export const FormDesignerComponentPropertiesFontSize = (
    props: IFormDesignerComponentPropertiesFontSizeProps
) => {
    //NOTE: class name may be used in other style class as prefix or suffix => need to use padding (problem: sText <=> sTextArea)
    const classes = " " + (props.taskTypeCol?.class ?? "") + " ";

    const handleSelectChange = (event: SelectChangeEvent) => {
        let value = classes;
        for (const sizeOption of props.sizeOptions) {
            if (sizeOption.class) {
                value = value.replace(" " + sizeOption.class + " ", " ");
            }
            if (sizeOption.class2) {
                value = value.replace(" " + sizeOption.class2 + " ", " ");
            }
        }
        props.onChange([{
            field: props.taskTypeCol?.field,
            name: "class",
            value: value.trim() + ` ${event.target.value}`
        }]);
    };

    const fontSize = getTextSize(classes, props.sizeOptions);

    return (
        <Select name="fontSize" value={fontSize} onChange={handleSelectChange}>
            {props.sizeOptions.map((sizeOption) => (
                <MenuItem key={sizeOption.title} value={sizeOption.class}>{sizeOption.title}</MenuItem>
            ))}
        </Select>
    );
};
